export const syncVideoWithTimeline = (progress: number) => {
    const videos = document.getElementsByClassName(
        "cropVideo"
    ) as HTMLCollectionOf<HTMLVideoElement>

    if (videos && videos.length > 0) {
        Array.from(videos).forEach((video) => {
            if (video.readyState >= 2) {
                video.currentTime = video.duration * progress
            }
        })
    }
}
